module.exports = __webpack_public_path__ + "img/订单icon.aa77fd42.svg";